var $export = require(61);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !require(57), 'Object', { defineProperty: require(86).f });
